var map = {
	"./acompanhamento.svg": "XRzE",
	"./aprendizado-coletivo.svg": "1w2f",
	"./conteudos-estudados.svg": "d1K8",
	"./dinamicas-dos-encontros.svg": "t9dS",
	"./erro-construtivo.svg": "rLse",
	"./niveis-de-robotica.svg": "tib2",
	"./robotica-educacional.svg": "OGim"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rOkI";